module.exports = __webpack_public_path__ + "img/hometogo.11f7712b.svg";